// import React, { useState } from 'react';
// import { motion } from 'framer-motion';
// import { FaApple, FaGooglePlay, FaStar } from 'react-icons/fa';

// const GameCard = ({ game }) => {

//    return (
//      <motion.div className="w-full h-full">
//        <motion.a
//          href={game.url}
//          target="_blank"
//          rel="noopener noreferrer"
//          className="block rounded-2xl relative duration-300 hover:scale-110 active:scale-110 md:hover:scale-105 md:active:scale-105"
//        >
//          {/* Card content (always visible) */}
//          <div className="rounded-3xl overflow-hidden h-full bg-white relative z-10">
//            <img
//              src={game.preview}
//              alt={game.title}
//              className="w-full aspect-square object-cover transition-transform duration-300 hover:scale-105 active:scale-105"
//            />

//            {/* App Name + Rating */}
//            <div className="pt-3 px-2 text-center">
//              <h3 className="text-lg font-bold text-[#2F3E5C] font-[Fredoka]">
//                {game.title}
//              </h3>

//              <div className="flex items-center justify-center gap-1 text-amber-400 mt-1">
//                <FaStar />
//                <span className="text-sm font-semibold text-[#2F3E5C]">
//                  {game.rating}
//                </span>
//              </div>
//            </div>
//          </div>
//        </motion.a>
//      </motion.div>
//    );
// }

// export default GameCard;

import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaApple, FaGooglePlay, FaStar } from "react-icons/fa";

const GameCard = ({ game }) => {
 return (
   <motion.a
     href={game.url}
     target="_blank"
     rel="noopener noreferrer"
     className="block rounded-2xl overflow-hidden bg-white flex flex-col shadow-xl transition-transform duration-300 hover:scale-105"
   >
     {/* Image */}
     <div className="w-full aspect-[1024/500] overflow-hidden">
       <img
         src={game.preview}
         alt={game.title}
         className="w-full h-full object-cover transition-transform duration-300 hover:scale-105 active:scale-105"
       />
     </div>

     {/* Content */}
     <div className="flex  items-center justify-between px-3 pt-3 pb-4">
       <div className="flex items-center gap-3 px-3 w-full">
         {/* App Icon */}
         <img
           src={game.icon}
           alt={game.title}
           className="w-10 h-10 rounded-lg object-cover"
         />

         {/* Title */}
         <h3 className="text-lg md:text-xl  text-[#2F3E5C] font-baloo font-bold">
           {game.title}
         </h3>
       </div>

       <div className="flex justify-center items-center gap-1">
         <FaStar className="text-yellow-400 w-4 h-4" />
         <span className="text-md font-baloo font-semibold text-[#2F3E5C]">
           {game.rating}
         </span>
       </div>
     </div>
   </motion.a>
 );
};

export default GameCard;